/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { BadgeImage } from 'shared/libs/providers/badge-editor/elements/image';

import ImageSelector from './panels/ImageSelector.vue';
import RemoveActiveObject from './panels/RemoveActiveObject.vue';
import ArrangementControls from './panels/ArrangementControls.vue';
import PositionControls from './panels/PositionControls.vue';
import DimensionControls from './panels/DimensionControls.vue';
import RotationControls from './panels/RotationControls.vue';
import ToolControls from './panels/ToolControls.vue';
import panelActions from './mixins/panel-actions';

const __vue_script__ = {
    name: 'ImagePanel',

    components: {
        ArrangementControls,
        DimensionControls,
        ImageSelector,
        PositionControls,
        RemoveActiveObject,
        RotationControls,
        ToolControls,
    },

    mixins: [panelActions],

    props: {
        id: {
            type: String,
            required: true,
        },
        value: {
            type: BadgeImage,
            required: true,
        },
        event: {
            type: Object,
            required: true,
        },
        imageAssets: {
            type: Array,
            required: true,
        },
        pageDimensions: {
            type: Object,
            required: true,
        },
        preset: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            aspectRatio: this.calculateAspectRatio(),
        };
    },

    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(value) {
                return this.$emit('input', value);
            }
        }
    },

    watch: {
        'value.id'() {
            this.aspectRatio = this.calculateAspectRatio();
        }
    },

    methods: {
        calculateAspectRatio() {
            if (this.value.width && this.value.height) {
                return this.value.width / this.value.height;
            }
            return null;
        },

        onImageChange(imageId) {
            const asset = this.imageAssets.find(({ _id }) => _id === imageId);
            if (asset) {
                this.$emit('image-change', { id: this.id, imageId });
            }
        },

        onChange({ property, value }) {
            this.innerValue[property] = value;

            if (this.aspectRatio) {
                if (property === 'width') {
                    this.innerValue.height = Math.round(value / this.aspectRatio);
                }
                if (property === 'height') {
                    this.innerValue.width = Math.round(value * this.aspectRatio);
                }
            }
        },
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-panel"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_c('i',{staticClass:"icon ic-background-element"}),_c('h4',[_vm._v(_vm._s(_vm.$t('badge_editor.image_panel')))])]),_c('div',{staticClass:"controls"},[_c('button',{staticClass:"btn btn-icon single btn-primary-alt close",on:{"click":function($event){return _vm.$emit('close-panel')}}},[_c('i',{staticClass:"icon ic-x"})])])]),_c('div',{staticClass:"note"},[_vm._v(_vm._s(_vm.$t('badge_editor.image_panel_note')))]),(_vm.preset.includes('zebra_zd621'))?_c('div',{staticClass:"alert info"},[_vm._v(_vm._s(_vm.$t('badge_editor.image_panel_printer_alert')))]):_vm._e(),_c('div',{staticClass:"section"},[_c('image-selector',{attrs:{"event":_vm.event,"image-assets":_vm.imageAssets,"value":_vm.innerValue.id},on:{"input":_vm.onImageChange}})],1),_c('div',{staticClass:"section parameters"},[_c('dimension-controls',{attrs:{"width":_vm.innerValue.width,"height":_vm.innerValue.height,"page-dimensions":_vm.pageDimensions},on:{"change":_vm.onChange}}),_c('position-controls',{attrs:{"top":_vm.innerValue.top,"left":_vm.innerValue.left,"page-dimensions":_vm.pageDimensions},on:{"change":_vm.onChange}}),_c('arrangement-controls',{attrs:{"page-dimensions":_vm.pageDimensions},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}}),(false)?_c('tool-controls',{attrs:{"value":_vm.innerValue,"flip-enabled":true},on:{"change":_vm.onChange,"duplicate":_vm.onDuplicate}}):_vm._e(),(false)?_c('rotation-controls',{attrs:{"angle":_vm.innerValue.angle},on:{"change":_vm.onChange}}):_vm._e()],1),_c('div',{staticClass:"section actions"},[_c('remove-active-object',{on:{"click":_vm.onRemove}})],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ImagePanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__